import { Flex } from 'antd';
import { useToken } from '@/common/helper';
import { CUSTOMER_LEG_CALENDAR_STATUS_COLORS } from './CalendarHelpers';

export type CalendarLegendLegType = 'CL' | 'EL';

type CalendarLegendItem = { label: string; color: string };

const LEGACY_CALENDAR_LEGENDS: CalendarLegendItem[] = [
  { label: 'Awaiting pickup', color: 'var(--text-tertiary)' },
  { label: 'In transit', color: 'var(--light-blue)' },
  { label: 'Delivery exception', color: 'var(--danger)' },
  { label: 'Delivered', color: '#0CBDBA' },
  { label: 'Pending', color: '#FFC043' },
  { label: 'Not found', color: '#FF6600' },
];

const CUSTOMER_LEG_CL_LEGENDS: CalendarLegendItem[] = [
  {
    label: 'Incomplete',
    color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.INCOMPLETE,
  },
  { label: 'Pending', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.PENDING },
  { label: 'Rated', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.RATED },
  {
    label: 'In transit',
    color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.IN_TRANSIT,
  },
  { label: 'Delivered', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.DELIVERED },
  { label: 'Cancelled', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.CANCELLED },
];

const CUSTOMER_LEG_EL_LEGENDS: CalendarLegendItem[] = [
  { label: 'Pending', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.PENDING },
  { label: 'Rated', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.RATED },
  { label: 'Booked', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.BOOKED },
  {
    label: 'In transit',
    color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.IN_TRANSIT,
  },
  { label: 'Delivered', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.DELIVERED },
  { label: 'Cancelled', color: CUSTOMER_LEG_CALENDAR_STATUS_COLORS.CANCELLED },
];

export const getCalendarLegendItems = (
  enableCustomerLeg: boolean,
  legType: CalendarLegendLegType = 'CL'
): CalendarLegendItem[] => {
  if (!enableCustomerLeg) return LEGACY_CALENDAR_LEGENDS;
  return legType === 'EL' ? CUSTOMER_LEG_EL_LEGENDS : CUSTOMER_LEG_CL_LEGENDS;
};

const ColorLegends = ({
  legType = 'CL',
}: {
  legType?: CalendarLegendLegType;
}) => {
  const { decodedUserToken } = useToken();
  const enableCustomerLeg = Boolean(decodedUserToken()?.enablecustomerleg);
  const legends = getCalendarLegendItems(enableCustomerLeg, legType);

  return (
    <>
      {legends.map((item) => (
        <Flex align='center' gap={4} key={item.label}>
          <span
            className='status-dot'
            style={{
              background: item.color,
            }}
          />
          <span className='zl-para-10'>{item.label}</span>
        </Flex>
      ))}
    </>
  );
};

export default ColorLegends;
